import { noop } from 'lodash';
import type React from 'react';
import classNames from 'classnames';
import { ForgeButton, ForgeIcon } from '@tylertech/forge-react';
import { I18n } from 'common/i18n';

export function FilterFooter({
  disableApplyFilter,
  isDrilldown = false,
  isReadOnly,
  showApplyButton = true,
  onClickApply = noop,
  onClickRemove,
  onClickReset,
  showRemoveButton = false,
}: {
  showApplyButton?: boolean;
  disableApplyFilter?: boolean;
  isDrilldown?: boolean;
  isReadOnly?: boolean;
  onClickApply?: (e: React.MouseEvent) => void;
  onClickRemove?: (e: React.MouseEvent) => void;
  onClickReset?: (e: React.MouseEvent) => void;
  showRemoveButton?: boolean;
}) {
  const handleKeyDown =
    (callback: ((e: React.MouseEvent) => void) | undefined) => (event: React.KeyboardEvent) => {
      if ((event.code === 'Enter' || event.code === 'Space') && callback) {
        event.preventDefault();
        callback(event as unknown as React.MouseEvent);
      }
    };
  const containerClasses = classNames('filter-footer', {
    'no-apply-button': !showApplyButton,
  });

  const reallyShowRemove = showRemoveButton && !(isReadOnly || isDrilldown);

  return (
    <div className={containerClasses}>
      {reallyShowRemove ? (
        <ForgeButton className="remove-btn" data-testid="remove-filter-button" onClick={onClickRemove}>
          <ForgeIcon name="delete" external external-type="standard" />
          {I18n.t('shared.components.filter_bar.remove')}
        </ForgeButton>
      ) : (
        // Use an empty div instead of null so flexbox works properly
        <div />
      )}

      <div className="apply-btn-container">
        {!!onClickReset && (
          <ForgeButton
            className="reset-btn"
            data-testid="reset-filter-button"
            onClick={onClickReset}
            onKeyDown={handleKeyDown(onClickReset)}
            aria-label={I18n.t('shared.components.filter_bar.reset')}
          >
            {I18n.t('shared.components.filter_bar.reset')}
          </ForgeButton>
        )}
        {showApplyButton && (
          <ForgeButton
            variant="raised"
            className="apply-btn"
            onClick={onClickApply}
            onKeyDown={handleKeyDown(onClickApply)}
            aria-label={I18n.t('shared.components.filter_bar.apply')}
            disabled={disableApplyFilter}
            data-testid="apply-filter-button"
          >
            {I18n.t('shared.components.filter_bar.apply')}
          </ForgeButton>
        )}
      </div>
    </div>
  );
}
